import React from 'react';
import { AnalyticsEvents } from '../../../../components/analytics/analyticsEvents';
import {
  IdleCalculationModeId, ProcessingConfigurationDataMappingField,
  TelematicsDeviceInputConfigurationApi
} from '../../stores/TelematicsDeviceConfiguration/TelematicsDeviceInputConfigurationApi';
import CustomConfiguration from './CustomConfiguration';
import { HiltiCustomConfigurationKey, HiltiCustomConfigurationName } from './CustomConfigurationStatus';

const HiltiServiceVanConfiguration: React.FC = () => (
  <CustomConfiguration
    configurationKey={HiltiCustomConfigurationKey.SERVICE_VAN}
    configurationName={HiltiCustomConfigurationName.SERVICE_VAN}
    analyticsEvent={AnalyticsEvents.HiltiServiceVanConfiguration}
    additionalSetup={(accessToken, serialNumber) =>
      TelematicsDeviceInputConfigurationApi.updateInputProcessingConfiguration(accessToken, serialNumber, {
        idleCalculationMode: IdleCalculationModeId.CAR,
        dataMappings: {
          operatingHours: ProcessingConfigurationDataMappingField.RUN_ODO,
          productiveHours: ProcessingConfigurationDataMappingField.NONE,
        },
      })
    }
  />
);

export default HiltiServiceVanConfiguration;
